<template>
  <div>
    <div class="m3phkn-inputarea-contents">
      <m3-login-link
        >m3.com会員情報を呼び出す<span>ログイン</span></m3-login-link
      >
      <wishful-time-form :nextLinkClicked="nextLinkClicked" />
    </div>
    <error-item-message
      :formFields="formFieldDictionary"
      :anotherCondition="nextLinkClicked"
    />
  </div>
</template>

<script setup>
import { onBeforeRouteLeave } from 'vue-router';
import { onActivated, nextTick, computed, watch } from 'vue';
import { useForm, useIsFormValid } from 'vee-validate';
import { validateForm } from '@component_path/slide_form_common_module/modules/validateFormBeforeRouteLeave';
import M3LoginLink from '@component_path/slide_form_common_module/components/others/m3_login_link';
import WishfulTimeForm from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/form_item_template/WishfulTime';
import ErrorItemMessage from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/others/ErrorItemMessage';

const { validate } = useForm();
const isValid = useIsFormValid();
const emit = defineEmits(['transit', 'back-slide', 'next-slide', 'is-valid']);

const props = defineProps({
  nextLinkClicked: {
    type: Boolean,
    required: true
  }
});

const formFieldDictionary = computed(() => ({
  wishful_time: '転職希望時期'
}));

onActivated(async () => {
  await nextTick(async () => {
    const { valid } = await validate();
    emit('is-valid', valid);
    document.getElementsByClassName('contact-btn__back')[0].style.display =
      'none';
    document.getElementsByClassName('contact-btn__next')[0].style.width =
      '100%';
  });
});

onBeforeRouteLeave(async (to, from, next) => {
  await validateForm(to, from, next, validate, emit);
});

watch(isValid, () => emit('is-valid', isValid.value));
</script>
